import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { OptionButton } from '../../../../utils/Button';
import { TableSortArrow } from '../../../../utils/IconComp';
import InstOption from '../../../../utils/InstOption';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';
import sortData from '../../../../utils/sortData';

function TableRow({ item, handleReload }) {
    const navigate = useNavigate();
    const { openModal } = useTemplate();
    const [showMenu, setShowMenu] = useState(false);
    const handleShowInstMenu = () => {
        setShowMenu((d) => !d);
    };
    const handleView = (id) => {
        navigate(mkRelativeUrl(`/billing/invoices/${id}/info`));
    };

    const getStatusClass = (status) => {
        switch (status.toLowerCase()) {
            case 'active':
                return 'text-secondary';
            case 'pending':
                return 'text-warning';
            case 'no-action':
                return 'text-error';
            default:
                return 'text-primary';
        }
    };

    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.invoiceItemId}</span>
            </td>
            <td onClick={() => handleView(item?.invoiceId)}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.invoiceId}
                </span>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.invoiceTitle || '-----------'}
                </span>
            </td>
            <td
                // onClick={() => navigate(mkRelativeUrl(`/customers/${item?.user?.id}/info`))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                {/* <span className="group-hover:font-medium text-ellipsis block w-full overflow-hidden" /> */}
                <Link
                    to={`/agency/${item?.user?.agencyId || 0}/customers/${item?.user?.id}/info`}
                    className="group-hover:font-medium text-ellipsis block w-full overflow-hidden"
                >
                    {item?.user?.organization || '-----'}
                </Link>
                <span className="text-ellipsis block w-full overflow-hidden">
                    {item?.user?.primaryEmail || '----'}
                </span>
            </td>
            <td>
                <span className="capitalize">{item?.productType}</span>
            </td>
            <td>
                <span>{item?.serviceName || '----'}</span>
            </td>
            <td>
                <span>{item?.packageName || '----'}</span>
            </td>
            <td>
                <span>{GetDate(item?.subscriptionStart) || 'No Start Date'}</span>
            </td>
            <td
                className={cn('text-center', {
                    '*:!font-medium': item?.expireSoon,
                    '*:text-error': item?.expireDay <= 30,
                    '*:text-yellow-400': item?.expireDay <= 45 && item?.expireDay > 30
                })}
            >
                <span>{GetDate(item?.timeUpdated) || 'No End Date'}</span>
            </td>
            <td className="text-center capitalize">
                <span className={getStatusClass(item?.status || '----')}>{item?.status}</span>
            </td>
            <td className="text-center">
                <span>
                    <div className="flex flex-row w-full justify-end relative">
                        <OptionButton
                            onClick={handleShowInstMenu}
                            disabled={item?.status === 'no-action'}
                        />
                        <InstOption
                            showMenu={showMenu}
                            setShowMenu={setShowMenu}
                            className="w-44 -right-3"
                        >
                            {item?.status === 'pending' && (
                                <button
                                    type="button"
                                    onClick={() =>
                                        openModal('PENDING_SERVICE_INITIATE', {
                                            item,
                                            handleReload
                                        })
                                    }
                                >
                                    Mark as Initiate
                                </button>
                            )}
                        </InstOption>
                    </div>
                </span>
            </td>
        </tr>
    );
}
function TableHeader({ sortBy, sortedColumn, sortedHandler }) {
    return (
        <thead>
            <tr>
                <th scope="col" onClick={() => sortedHandler('id')}>
                    <span className="">ID</span>
                    <TableSortArrow name="id" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col" onClick={() => sortedHandler('invoice-id')}>
                    <span className="">Invoice ID</span>
                    <TableSortArrow name="invoice-id" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col">
                    <span>Customer Info.</span>
                </th>
                <th scope="col">
                    <span>Product Type</span>
                </th>
                <th scope="col">
                    <span>Service Name</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Package Name</span>
                </th>
                <th scope="col">
                    <span>Start Date</span>
                </th>
                <th
                    scope="col"
                    className="!w-40 text-center"
                    onClick={() => sortedHandler('service-update')}
                >
                    <span>Service Update</span>
                    <TableSortArrow
                        name="service-update"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th scope="col" className="w-30 text-center">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Service Status">
                        Status
                    </span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function ServicePendingTable({ data, handleReload, sortedHandler, sortedColumn, sortBy }) {
    const isAsc = sortBy === 'asc';

    let column = '';
    if (sortedColumn === 'id') {
        column = 'invoiceItemId';
    }
    if (sortedColumn === 'invoice-id') {
        column = 'invoiceId';
    }
    if (sortedColumn === 'service-update') {
        column = 'timeUpdated';
    }

    const arr = sortData(data?.servicesList, column, isAsc);

    return (
        <div className="service_pending_page_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    sortedHandler={sortedHandler}
                    sortBy={sortBy}
                    sortedColumn={sortedColumn}
                />
                <tbody>
                    {data && data.servicesList.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={8} className="!text-left">
                                No Pending Services Found!
                            </td>
                        </tr>
                    ) : (
                        arr?.map((item) => (
                            <TableRow
                                key={item?.invoiceItemId}
                                item={item}
                                handleReload={handleReload}
                            />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ServicePendingTable;
